import { styled } from '@eversports/react-components/design-tokens/styled-components'

export const phoenixAllowList = {
  p: [],
  br: [],
  ul: [],
  ol: [],
  li: [],
  strong: [],
  em: [],
  a: ['href', 'target', 'rel'],
}

export const onATag = (tag: string, html: string) => {
  if (tag === 'a') {
    return html.replace(/<a [^>]*>|<\/a>/gi, '')
  }

  return undefined
}

const HTMLFormattedContentWrapper = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: 0.03125rem;

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: 0.03125rem;
    margin-bottom: 0.5rem;
  }

  li {
    line-height: 1.5rem;
  }

  ol {
    margin: 8px 24px;
    list-style: auto;
  }

  ul {
    margin: 8px 24px;
    list-style: disc;
  }

  strong,
  b {
    font-weight: bold;
  }

  i,
  em {
    font-style: italic;
  }
`

export default HTMLFormattedContentWrapper
